import React from "react";
import OrderTableItem from "./OrderTableItem";
import {connect} from "react-redux";

function OrdersTable(props) {
    return (
        <div className="s-table">
            <div className="s-table-container">
                <div className="s-table-container__box">
                    <div className="o-table-item__header">
                        <div className="o-table-item">
                            <div className="o-table-item__name">
                                <div className="c-table-item">Naam</div>
                            </div>
                            <div className="o-table-item__ordered-products-container">
                                <div className="o-table-item__products">
                                    <div className="o-table-item__product">
                                        <div className="c-table-item">
                                            Bestelde artikelen
                                        </div>
                                    </div>

                                    <div className="o-table-item__product-price">
                                        <div className="c-table-item">
                                            Prijs
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="o-table-item__total-price-header">
                                <div className="c-table-item">Totaalprijs</div>
                            </div>
                        </div>
                    </div>

                    {props.table
                        // .reverse()
                        .map((item, key) => {
                            return (<OrderTableItem item={item} key={item.increment_id}/>);
                        })}
                </div>
            </div>
        </div>
    );
}

let orderTable = [];
let order;
const mapStateToProps = (state = {}) => {
    const result = {
        table: orderTable
    };

    if (typeof state.data === "undefined") {
        return result;
    }

    if (typeof state.data["event-order-place"] !== "undefined"
        && order !== state.data["event-order-place"]) {
        order = state.data["event-order-place"];
        orderTable.unshift(order);
        if (orderTable.length > 5) {
            orderTable.pop();
        }
        result.table = [...orderTable];
    }

    return result;
};

export default connect(mapStateToProps)(OrdersTable);

